export const listingStatus = ['Active','In Active','Archived']
export const statuses = ['Active','InActive','Archived']
export const showOnSiteStatus = ['No','Yes','Off Market Listing']